"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    name: {
        id: "dashboard.name",
        defaultMessage: "Páciens neve"
    },
    status: {
        id: "dashboard.status",
        defaultMessage: "Státusz"
    },
    ssn: {
        id: "dashboard.social_security_number",
        defaultMessage: "TAJ"
    },
    address: {
        id: "dashboard.address",
        defaultMessage: "Lakhely"
    },
    phoneNumber: {
        id: "dashboard.phone_number",
        defaultMessage: "Telefon"
    },
    bloodGroup: {
        id: "dashboard.blood_group",
        defaultMessage: "Vércsoport"
    },
    age: {
        id: "dashboard.age",
        defaultMessage: "Életkor"
    },
    weight: {
        id: "dashboard.weight",
        defaultMessage: "Testsúly"
    },
    height: {
        id: "dashboard.height",
        defaultMessage: "Magasság"
    },
    bmi: {
        id: "dashboard.bmi",
        defaultMessage: "BMI"
    },
    dashboard: {
        id: "dashboard.dashboard",
        defaultMessage: "Dashboard"
    }
};
